const ktTouchEvents = ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) ? true : false;

// main header ( controlls all things heaader & menu related, including sidebar drawer connections ) 

class MainHeader extends HTMLElement {

	constructor() {
		super();
		this._headerWrapper = document.getElementById('header-container');
		this._lastFittingWidth = window.innerWidth;
		this.mount();
	}

	mount(){

		// add inert elements

		document.querySelectorAll('#main > div').forEach(elm=>{
			if ( ! elm.classList.contains('no-inert') ) {
				elm.setAttribute('data-js-inert', '');
			}
		})
		window.inertElems = document.querySelectorAll('[data-js-inert]');

		// drawer connections

		document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
			if ( elm.hasAttribute('aria-controls') ) {
				const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
				elm.addEventListener('click', e=>{
					e.preventDefault();
					elm.setAttribute('aria-expanded', 'true');
					if ( elm.hasAttribute('data-js-sidebar-handle-direction') ) {
						elmSidebar.setAttribute('data-direction', elm.getAttribute('data-js-sidebar-handle-direction'));
					}
					elmSidebar.show();
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
						elmSidebar.querySelector('[data-js-close]').focus();
					}
				})
			}
		});

		document.querySelectorAll('[data-js-sidebar-handle][aria-controls="site-menu-sidebar"]').forEach(elm => {
			elm.addEventListener('click', e=>{
				document.querySelectorAll('#site-menu-sidebar img').forEach(img => {
					KROWN.functions.setImagesize(img);
				});
			})
		});

		if ( document.getElementById('site-cart-sidebar') ) {
			this.querySelector('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]')?.addEventListener('click', e=>{
				KROWN.functions.eventDispatcher('krown:cart-sidebar:show', {
					sidebarElement: document.getElementById('site-cart-sidebar')
				});
			});
		}
		
		// closing drawers

		document.querySelector('.kt-site-overlay').addEventListener('click', ()=>{
			if ( document.querySelector('.kt-sidebar--opened') ) {
				document.querySelector('.kt-sidebar--opened').hide();
			}
		});
		document.addEventListener('keydown', e=>{
			if ( e.keyCode == window.KEYCODES.ESC ) {
				if ( document.querySelector('.kt-sidebar--opened') ) {
					document.querySelector('.kt-sidebar--opened').hide();
				}
			}
		});

		// resizing drawers

		const rootHeight = document.getElementById('root-height');
		this.RESIZE_SidebarHelper = debounce(()=>{
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
				--sidebar-width: ${window.innerWidth}px;
			}`;
		}, 20);
		window.addEventListener('resize', this.RESIZE_SidebarHelper);
		rootHeight.innerHTML = `:root {
			--window-height: ${window.innerHeight}px;
			--window-width: ${document.body.clientWidth}px;
		}`;
		document.body.classList.add('kt-header-loaded');

		// switch menu (on load and on resize)
		this._previousWidth = window.innerWidth;
		this._updateCompactedState();

		window.addEventListener('resize', debounce(()=>{
			const currentWidth = window.innerWidth;
			this._updateCompactedState();
			this._previousWidth = currentWidth;
		}, 50));

		// sticky header + background color
		const stickyUp = document.body.classList.contains('kt-header-is-sticky-when-scrolling');

		if ( stickyUp ) {
			window.kt_lst = window.scrollY;
			window.kt_lhp = 0;
			window.kt_sot = 0;
			window.kt_sotelm = this.closest('header')
		}

		if ( this._headerWrapper.classList.contains('kt-header-wrapper--sticky') || stickyUp ) {
			let scrollTicking = false;
			window.addEventListener('scroll', () => {
				if (!scrollTicking) {
					scrollTicking = true;
					const headerPosition = this.closest('header').offsetTop;
					requestAnimationFrame(() => {

						scrollTicking = false;

						if ( ! stickyUp ) {

							if ( window.scrollY >= headerPosition ) {
								this._headerWrapper.classList.add('kt-header-wrapper--is-sticking');
							} else {
								this._headerWrapper.classList.remove('kt-header-wrapper--is-sticking');
							}
							
							if ( window.scrollY > 100 ) {
								this._headerWrapper.classList.add('kt-header-wrapper--is-scrolling');
							} else {
								this._headerWrapper.classList.remove('kt-header-wrapper--is-scrolling');
							}

						} else if ( stickyUp ) {
							let st = window.scrollY;

							if ( st == 0 || st <= window.kt_sot  ) {
								this._headerWrapper.classList.remove('kt-header-wrapper--is-sticking');
								this._headerWrapper.classList.remove('kt-header-wrapper--is-animating');
							}

							if ( st < 0 || Math.abs(kt_lst - st) <= 5 ) {
								return;	
							}

							if ( st > window.kt_lhp && st > window.kt_sot ) {
								if ( st == 0 && this._headerWrapper.classList.contains('kt-header-wrapper--is-sticking') ) {
									this._headerWrapper.classList.remove('kt-header-wrapper--is-sticking')
									this._headerWrapper.classList.remove('kt-header-wrapper--is-animating');
								} else if ( st <= kt_lst && ! this._headerWrapper.classList.contains('kt-header-wrapper--is-sticking') ) {
									window.kt_lhp = this._headerWrapper.offsetTop;
									if ( Math.abs(this._headerWrapper.getBoundingClientRect().top) > this._headerWrapper.offsetHeight ) {
										window.kt_sot = window.kt_sotelm.offsetTop > 0 ? window.kt_sotelm.offsetTop : window.kt_sot;
										this._headerWrapper.classList.add('kt-header-wrapper--is-sticking');
										this._headerWrapper.classList.add('kt-header-wrapper--is-animating');
									}
								} else if ( st > kt_lst && this._headerWrapper.classList.contains('kt-header-wrapper--is-sticking') ) {
									this._headerWrapper.classList.remove('kt-header-wrapper--is-sticking');
									this._headerWrapper.classList.remove('kt-header-wrapper--is-animating');
								}
								
							}

							window.kt_lst = st;
							
						}

					});
				}
			}, { passive: true });
		}

		const fullHeader = document.getElementById('shopify-section-header');
		if ( fullHeader ) {
			fullHeader.querySelectorAll('.kt-localization-form__item-button').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					fullHeader.querySelectorAll('.kt-localization-form__item-button.kt-active').forEach(elm=>{
						elm.classList.remove('kt-active');
					});
					elm.classList.add('kt-active');
					window.ktMenu.updateHeaderState();
				})
			});

			fullHeader.querySelectorAll('.kt-menu__link, .kt-logo, .kt-localization-form__item-button').forEach(elm=>{
				elm.addEventListener('mouseenter', ()=>{
					window.ktMenu.closeAll({ exceptEl: elm, includeChain: true, closeLocalization: false });
				})
			});

			if ( ! ktTouchEvents ) {
				fullHeader.addEventListener('mouseleave', ()=>{
					window.ktMenu.closeAll({ exceptEl: null, includeChain: true, closeLocalization: false });
				});
			}
		}

		// predictive search

		if ( document.getElementById('shopify-features') && JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

			document.querySelectorAll('[data-js-open-search-drawer').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! document.body.classList.contains('predictive-script-loaded') ) {
						document.body.classList.add('predictive-script-loaded')
						const predictiveSearchJS = document.createElement('script');
						predictiveSearchJS.src = KROWN.settings.predictive_search_script;
						document.head.appendChild(predictiveSearchJS); 
					}
					setTimeout(()=>{
						document.querySelector('#site-search-sidebar input[type="search"]').focus();
					}, 200)
				});
			});

		} else {

			this.querySelector('search-form')?.addEventListener('click', e=>{
				e.preventDefault();
				window.location.href = KROWN.settings.routes.search_url;
			});

		}

	}

	unmount(){
		window.removeEventListener('resize', this.RESIZE_SidebarHelper);
	}
	
	_updateCompactedState() {
		const header = this;
		const cells = header.querySelectorAll('.kt-header__cell');
		
		if (!cells.length) return;
	
		const headerRect = header.getBoundingClientRect();
		const availableWidth = headerRect.width;
	
		if (!this.classList.contains('kt-js-header--show-compacted')) {
			let minLeft = Infinity;
			let maxRight = -Infinity;
	
			cells.forEach((cell) => {
				const rect = cell.getBoundingClientRect();
				if (!rect.width) return;
				if (rect.left < minLeft) minLeft = rect.left;
				if (rect.right > maxRight) maxRight = rect.right;
			});
	
			if (!isFinite(minLeft) || !isFinite(maxRight)) return;
	
			const usedWidth = maxRight - minLeft;
	
			if (usedWidth <= availableWidth + 1) {
				this._lastFittingWidth = availableWidth;
				this.classList.remove('kt-js-header--show-compacted');
			} else {
				this.classList.add('kt-js-header--show-compacted');
			}
	
		} else {
			if (this._lastFittingWidth && availableWidth >= this._lastFittingWidth) {
				this.classList.remove('kt-js-header--show-compacted');
			}
		}
	}

}

customElements.define('main-header', MainHeader);

// sidebar drawer class ( used for all drawers within the theme )

class SidebarDrawer extends HTMLElement {

	constructor(){
		super();
		this.querySelector('[data-js-close]').addEventListener('click', ()=>{
			this.hide();
		});
		document.addEventListener('keydown', e=>{
			if ( e.keyCode == window.KEYCODES.ESC ) {
				const openedSidebar = document.querySelector('sidebar-drawer.kt-sidebar--opened');
				if ( openedSidebar ){
					openedSidebar.hide();
				}
			}
		});
	}

	show(){

		this._opened = true;
		document.body.classList.add('kt-sidebar-opened');
		document.body.classList.add('kt-sidebar-opened-set-header-index');
		if ( this.dataset.direction == 'right' ) {
			document.body.classList.add('kt-sidebar-opened--right');
		} else if ( this.dataset.direction== 'left' ) {
			document.body.classList.add('kt-sidebar-opened--left');
		}
		if ( this.id == 'site-cart-sidebar' && document.querySelector('#cart-recommendations css-slider') ) {
			setTimeout(()=>{
				document.querySelector('#cart-recommendations css-slider').resetSlider();
			}, 10);
		}
		if ( this.id == 'site-menu-sidebar' ) {
			setTimeout(()=>{
				this.querySelectorAll('.kt-menu-promotions-container css-slider').forEach(slider => {
					if ( slider ) {
						slider.resetSlider();
					}
				});
			}, 50);
		}
		this.style.display = 'grid';
		window.KROWN.previouslyFocused = document.activeElement;
		setTimeout(()=>{
			this.classList.add('kt-sidebar--opened');
			window.inertElems.forEach(elm=>{
				elm.setAttribute('inert', '');
			})
		}, 15);

		setTimeout(()=>{
			if ( this.querySelector('[data-js-close]') ) {
				this.querySelector('[data-js-close]').focus();
			}
		}, 150);

	}

	hide(){

		this._opened = false;
		this.classList.remove('kt-sidebar--opened');

		document.body.classList.remove('kt-sidebar-opened');
		document.body.classList.remove('kt-sidebar-opened--left');
		document.body.classList.remove('kt-sidebar-opened--right');
		window.inertElems.forEach(elm=>{
			elm.removeAttribute('inert');
		})
		if ( window.KROWN.previouslyFocused ) {
			window.KROWN.previouslyFocused.focus();
			window.KROWN.previouslyFocused = null;
		}

		document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

		if ( this.id == 'site-cart-sidebar' ) {
			KROWN.functions.eventDispatcher('krown:cart-sidebar:hide', {
				sidebarElement: document.getElementById('site-cart-sidebar')
			});
		}

		setTimeout(()=>{
			this.style.display = 'none';
		}, 501);

		setTimeout(()=>{
			document.body.classList.remove('kt-sidebar-opened-set-header-index');
		}, 301);

	}

}

customElements.define('sidebar-drawer', SidebarDrawer);

// mobile navigation class ( only used for the mobile menu )

class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;
			this._openedSecondSubmenu = false;

			const animationsTimer = 195;
			const animationsTimerDelayed = 235;

			this.querySelectorAll('.kt-has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					this._handlePointerEvents();
					if ( ! this._openedFirstSubmenu ) {

						this._openedFirstSubmenu = true;
						this.classList.add('kt-opened-first-submenu');
						this.closest('sidebar-drawer').scrollTo({top: 0});
						e.target.closest('nav').classList.add('kt-opened-nav');

						e.target.closest('ul').querySelectorAll(':scope > li > a').forEach(elm=>{
							elm.setAttribute('inert', '');
						});

						this.querySelectorAll('nav').forEach(elm=>{
							this._animate(
								elm, 
								{translateX: 0, opacity: 1},
								{translateX: -50, opacity: 0},
								animationsTimer, 0
							);
							if ( elm.classList.contains('kt-opened-nav') ) {
								setTimeout(()=>{
									elm.style.transform = `translateX(-100%)`;
									elm.style.opacity = 1;
								}, animationsTimerDelayed);
							} else {
								setTimeout(()=>{
									elm.style.maxHeight = 0;
								}, animationsTimerDelayed);
							}
						});

						this._animate(
							e.target.closest('li').querySelector('.kt-submenu'), 
							{translateX: 150, opacity: 0},
							{translateX: 100, opacity: 1},
							animationsTimer, animationsTimer
						);
						
					}
					e.target.closest('li').classList.add('kt-opened');
					this._resizeContainer(e.target);
				})
			});

			this.querySelectorAll('.kt-has-babymenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					this._handlePointerEvents();
					if ( ! this._openedSecondSubmenu ) {

						this._openedSecondSubmenu = true;
						this.classList.add('kt-opened-second-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});

						e.target.closest('ul').querySelectorAll(':scope > li > a').forEach(elm=>{
							elm.setAttribute('inert', '');
						});

						this._animate(
							e.target.closest('nav.kt-opened-nav'), 
							{translateX: -100, opacity: 1},
							{translateX: -150, opacity: 0},
							animationsTimer, 0
						);
						setTimeout(()=>{
							e.target.closest('nav.kt-opened-nav').style.transform = `translateX(-200%)`;
							e.target.closest('nav.kt-opened-nav').style.opacity = 1;
						}, animationsTimerDelayed)

						this._animate(
							e.target.closest('li').querySelector('.kt-babymenu'), 
							{translateX: 150, opacity: 0},
							{translateX: 100, opacity: 1},
							animationsTimer, animationsTimer
						);

					}
					e.target.closest('li').classList.add('kt-opened');
					this._resizeContainer(false, e.target);
				})
			});

			this.querySelectorAll('.kt-submenu-back button').forEach(elm => {
				
				elm.addEventListener('click', e => {
					e.preventDefault();
					this._handlePointerEvents();
			
					if (this._openedSecondSubmenu) {
			
						this._animate(
							this.querySelector('nav.kt-opened-nav .kt-has-babymenu.kt-opened .kt-babymenu'),
							{ translateX: 100, opacity: 1 },
							{ translateX: 150, opacity: 0 },
							animationsTimer,
							0
						);
			
						setTimeout(() => {
							this._animate(
								this.querySelector('nav.kt-opened-nav'),
								{ translateX: -150, opacity: 0 },
								{ translateX: -100, opacity: 1 },
								animationsTimer,
								0
							);
						}, animationsTimer);
			
						setTimeout(() => {
							const babyHost = this.querySelector('nav.kt-opened-nav .kt-has-babymenu.kt-opened');
							if (babyHost) {
								babyHost.classList.remove('kt-opened');
								babyHost.closest('ul').querySelectorAll(':scope > li > a').forEach(elm=>{
									elm.removeAttribute('inert');
								});
							}
			
							this._openedSecondSubmenu = false;
							this.classList.remove('kt-opened-second-submenu');
							this.classList.remove('kt-reverse-second');
			
							this._resizeContainer(e.target);
						}, animationsTimerDelayed);

					} else if (this._openedFirstSubmenu) {
			
						this._animate(
							this.querySelector('nav.kt-opened-nav .kt-has-submenu.kt-opened .kt-submenu'),
							{ translateX: 100, opacity: 1 },
							{ translateX: 150, opacity: 0 },
							animationsTimer,
							0
						);
			
						setTimeout(() => {
							this.querySelectorAll('nav').forEach(navElm => {
								this._animate(
									navElm,
									{ translateX: -50, opacity: 0 },
									{ translateX: 0, opacity: 1 },
									animationsTimer,
									0
								);
								navElm.style.maxHeight = '100%';
							});
						}, animationsTimer);
			
						setTimeout(() => {
							const subHost = this.querySelector('nav.kt-opened-nav .kt-has-submenu.kt-opened');
							if (subHost) {
								subHost.classList.remove('kt-opened');
								subHost.closest('ul').querySelectorAll(':scope > li > a').forEach(elm=>{
									elm.removeAttribute('inert');
								});
							}
			
							this._openedFirstSubmenu = false;
							this.classList.remove('kt-opened-first-submenu');
			
							const openedNav = this.querySelector('nav.kt-opened-nav');
							if (openedNav) openedNav.classList.remove('kt-opened-nav');

							e.target.closest('ul').querySelectorAll(':scope > li > a').forEach(elm=>{
								elm.removeAttribute('inert');
							});

							this._resizeContainer(e.target);
						}, animationsTimerDelayed);
					}
			
					this.closest('sidebar-drawer').scrollTo({ top: 0 });
				});
			});

		}

		_resizeContainer(contextElm = null) {

			const allDrawers = this.querySelectorAll('.kt-drawer-menu');
			if (!allDrawers.length) return;
			const openedSubmenuClass = 'kt-drawer-menu--submenu-opened';
		
			const openBaby = this.querySelector('.kt-has-babymenu.kt-opened .kt-babymenu');
			const openSub  = this.querySelector('.kt-has-submenu.kt-opened > .kt-submenu');
			const activePanel = openBaby || openSub;
		
			if (!activePanel) {
				allDrawers.forEach(dm => {
					dm.classList.remove(openedSubmenuClass);
					dm.style.display = '';
					dm.style.height = 'auto';
				});
				return;
			}
		
			const activeDrawer =
				(contextElm && contextElm.closest('.kt-drawer-menu')) ||
				activePanel.closest('.kt-drawer-menu');
		
			if (!activeDrawer) return;
		
			allDrawers.forEach(dm => {
				dm.classList.toggle(openedSubmenuClass, dm === activeDrawer);
				if (dm === activeDrawer) {
					dm.style.display = '';
				} else {
					dm.style.display = 'none';
					dm.style.height = '0px';
				}
			});
		
			const height = activePanel.scrollHeight;
			activeDrawer.style.height = `${height}px`;

		}

		_handlePointerEvents() {
			this.style.pointerEvents = 'none';
			setTimeout(() => {
				this.style.pointerEvents = 'all';
			}, 300);
		}

		_animate(element, startProperties, endProperties, duration, delay = 0, easing = t => t){

			const initialProperties = {
				translateX: startProperties.translateX,
				opacity: startProperties.opacity,
				maxHeight: startProperties.maxHeight
			}; 
				
			if (startProperties.translateX !== undefined) {
				element.style.transform = `translateX(${startProperties.translateX})`;
			}
			if (startProperties.opacity !== undefined) {
				element.style.opacity = startProperties.opacity;
			}
			if (startProperties.maxHeight !== undefined) {
				element.style.maxHeight = startProperties.maxHeight;
			}

			const animationsEasing = (n) => {
  			return --n * n * n + 1;
			}

			setTimeout(() => {

        const startTime = performance.now();

				const deltas = {
					translateX: endProperties.translateX !== undefined ? parseFloat(endProperties.translateX) - parseFloat(initialProperties.translateX) : undefined,
					opacity: endProperties.opacity !== undefined ? endProperties.opacity - initialProperties.opacity : undefined,
					maxHeight: endProperties.maxHeight ? parseFloat(endProperties.maxHeight) - parseFloat(initialProperties.maxHeight) : undefined
				};

				const updateProperties = progress => {
					const easedProgress = animationsEasing(progress);
					if (deltas.translateX !== undefined) {
						const currentTranslateX = parseFloat(initialProperties.translateX) + deltas.translateX * easedProgress;
						element.style.transform = `translateX(${currentTranslateX}%)`;
					}
					
					if (deltas.opacity !== undefined) {
						const currentOpacity = initialProperties.opacity + deltas.opacity * easedProgress;
						element.style.opacity = currentOpacity;
					}

					if (deltas.maxHeight !== undefined) {
						const currentMaxHeight = parseFloat(initialProperties.maxHeight) + deltas.maxHeight * easedProgress;
						element.style.maxHeight = `${currentMaxHeight}%`;
					}
				};

				const animationStep = timestamp => {
					const elapsed = timestamp - startTime;
					let progress = Math.min(elapsed / duration, 1);
					updateProperties(progress);
					if (progress >= .9) {	
						if (endProperties.translateX !== undefined) {
							element.style.transform = `translateX(${endProperties.translateX})`;
						}
						if (endProperties.opacity !== undefined) {
							element.style.opacity = endProperties.opacity;
						}
						if (endProperties.maxHeight !== undefined) {
							element.style.maxHeight = endProperties.maxHeight;
						}
					} else {
						requestAnimationFrame(animationStep);
					}
				};

				requestAnimationFrame(animationStep);

    	}, delay);

		}

	}

customElements.define('mobile-navigation', MobileNavigation);

// central controller function & class for the menu

function ktUpdateHeaderWrapperState() {
  const header = document.querySelector('.kt-header-wrapper');
  if (!header) return;

	const hasOpened = document.querySelector(
    'item-is-dropdown.kt-active, .kt-menu__submenu.kt-opened, item-is-megamenu .kt-megamenu.kt-opened, .kt-localization-form__item-button.kt-active'
  );

  const hasSubmenuOpened = document.querySelector('.kt-menu__submenu.kt-opened');
  const hasMegaOpened = document.querySelector('item-is-megamenu .kt-megamenu.kt-opened');

  header.classList.toggle('kt-header-wrapper--has-opened-items', !!hasOpened);
  header.classList.toggle('kt-header-wrapper--has-opened-submenu', !!hasSubmenuOpened);
  header.classList.toggle('kt-header-wrapper--has-opened-megamenu', !!hasMegaOpened);
}

class KtMenuController {
  constructor() {
    this.headerSelector = '.kt-header-wrapper';

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    document.addEventListener('click', this.handleDocumentClick);
  }

  get header() {
    return document.querySelector(this.headerSelector);
  }

  updateHeaderState() {
    ktUpdateHeaderWrapperState();
  }

  buildKeepSet(exceptEl, includeChain = true) {
    const keep = new Set();
    if (!exceptEl) return keep;

    if (includeChain && exceptEl.closest) {
      let node = exceptEl;
      while (node) {
        if (node.matches?.('item-is-dropdown, item-is-megamenu')) {
          keep.add(node);
        }
        node = node.parentElement;
      }
    } else {
      keep.add(exceptEl);
    }

    return keep;
  }

  closeAll({ exceptEl = null, includeChain = true, closeLocalization = true } = {}) {
    const keep = this.buildKeepSet(exceptEl, includeChain);

    const shouldSkip = (el) => {
      if (!exceptEl) return false;
      for (const k of keep) {
        if (k.contains(el)) return true;
      }
      return false;
    };

    document.querySelectorAll('item-is-dropdown.kt-active').forEach(host => {
      if (shouldSkip(host)) return;
      host.classList.remove('kt-active');
      host.setAttribute('aria-expanded', 'false');
    });

    document.querySelectorAll('.kt-menu__submenu.kt-opened').forEach(ul => {
      if (shouldSkip(ul)) return;
      ul.classList.remove('kt-opened', 'kt-menu__submenu--flip');
      ul.style.removeProperty('--submenu-nudge-x');
      ul.style.removeProperty('--submenu-nudge-y');
    });

		if ( closeLocalization ) {
			document.querySelectorAll('.kt-localization-form__item-button.kt-active').forEach(elm=>{
				elm.classList.remove('kt-active');
				elm.setAttribute('aria-expanded', 'false');
				elm.closest('.kt-localization-form__item').querySelector('.kt-localization-form__content').classList.remove('kt-content-opened');
				elm.closest('.kt-localization-form__item').querySelector('.kt-localization-form__content').style.zIndex = 9;
			});
		}

    document.querySelectorAll('item-is-megamenu').forEach(mm => {
      if (shouldSkip(mm)) return;

      const menu = mm.querySelector('.kt-megamenu.kt-opened');
      const link = mm.querySelector('.kt-menu__link.kt-active');

      if (menu) menu.classList.remove('kt-opened');
      if (link) link.classList.remove('kt-active');

      mm.setAttribute('aria-expanded', 'false');
    });

    this.updateHeaderState();
  }

  handleDocumentClick(e) {
    if (e.target.closest('item-is-dropdown, item-is-megamenu')) return;
    this.closeAll();
  }
}

window.ktMenu = window.ktMenu || new KtMenuController();

// base class for shared helpers

class KtBaseMenuItem extends HTMLElement {
  getSubmenu() {
    return this.querySelector(':scope > .kt-menu__submenu, .kt-menu__submenu');
  }

  getTrigger() {
    return this.querySelector(
      ':scope > .kt-menu__link, :scope > .kt-menu__toggle, :scope > [aria-haspopup="true"]'
    );
  }

  setExpanded(open) {
    this.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  updateHeader() {
    window.ktMenu.updateHeaderState();
  }

  closeDescendants() {
    this.querySelectorAll('item-is-dropdown.kt-active').forEach(host => {
      host.classList.remove('kt-active');
      host.setAttribute('aria-expanded', 'false');
    });
    this.querySelectorAll('.kt-menu__submenu.kt-opened').forEach(ul => {
      ul.classList.remove('kt-opened', 'kt-menu__submenu--flip');
      ul.style.removeProperty('--submenu-nudge-x');
      ul.style.removeProperty('--submenu-nudge-y');
    });
  }
}

// item-is-dropdown class ( used for all dropdowns in the classic header menu )

class itemIsDropdown extends KtBaseMenuItem {
	constructor() {
		super();
		this.onSelfClick = this.onSelfClick.bind(this);
		this.onSelfKeydown = this.onSelfKeydown.bind(this);
		this.handleMouseEnter = this.onSelfMouseEnter.bind(this);
	}

	connectedCallback() {
		this.addEventListener('click', this.onSelfClick);
		this.addEventListener('keydown', this.onSelfKeydown);
		if ( ! ktTouchEvents ) {
			this.addEventListener('mouseenter', this.handleMouseEnter);
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onSelfClick);
		this.removeEventListener('keydown', this.onSelfKeydown);
		if ( ! ktTouchEvents ) {
			this.removeEventListener('mouseenter', this.handleMouseEnter);
		}
	}

	// keyboard activation: the trigger is an <a href="…">, so on desktop a click
	// no longer preventDefaults ( hover opens, click navigates ). Enter/Space must
	// still open the submenu for keyboard users, so handle them explicitly here.
	onSelfKeydown(e) {
		console.log(e.keyCode);
		if ( e.keyCode !== window.KEYCODES.RETURN ) return;

		const trigger = this.getTrigger();
		const target = e.target.closest('.kt-menu__link, .kt-menu__toggle, [aria-haspopup="true"]');

		// only act on this item's own trigger — let nested items handle their own keys
		if ( ! target || ( trigger && ! trigger.contains(target) ) ) return;

		e.preventDefault();
		e.stopPropagation();

		if ( this.classList.contains('kt-active') ) {
			this.setOpenState(false);
		} else {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.setOpenState(true);
		}
	}

	onSelfMouseEnter(e) {
		e.preventDefault();
		e.stopPropagation();
		if ( ! this.classList.contains('kt-active') ) {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.setOpenState(true);
		}
	}

	setOpenState(open, el = this) {
		el.classList.toggle('kt-active', open);
		this.setExpanded(open);

		const submenu = this.getSubmenu();
		if (submenu) {
			if (open) {
				document.querySelectorAll('.kt-menu__submenu--level-2.kt-opened').forEach(ul => {
					ul.classList.remove('kt-opened', 'kt-menu__submenu--flip');
					ul.style.removeProperty('--submenu-nudge-x');
					ul.style.removeProperty('--submenu-nudge-y');

					const host = ul.closest('item-is-dropdown');
					if (host) {
						host.classList.remove('kt-active');
						host.setAttribute('aria-expanded', 'false');
					}
				});
			} else {
				this.closeDescendants();
			}

			submenu.classList.toggle('kt-opened', open);
			if (open) {
				this.adjustSubmenuPosition(submenu);
			} else {
				submenu.classList.remove('kt-menu__submenu--flip');
				submenu.style.removeProperty('--submenu-nudge-x');
				submenu.style.removeProperty('--submenu-nudge-y');
			}
		} else if (!open) {
			this.closeDescendants();
		}

		this.updateHeader();
	}

	onSelfClick(e) {
		const submenu = this.getSubmenu();

		if (submenu && submenu.contains(e.target)) {
			const wantsClose = e.target.closest('[data-close-submenu]');
			if (wantsClose) {
				e.preventDefault();
				e.stopPropagation();
				this.setOpenState(false);
			}
			return;
		}

		const trigger = this.getTrigger();
		const clickedTrigger = e.target.closest(
			'.kt-menu__link, .kt-menu__toggle, [aria-haspopup="true"]'
		);
		if (!clickedTrigger || (trigger && !trigger.contains(clickedTrigger))) return;

		e.stopPropagation();
		if ( ktTouchEvents ) {
			e.preventDefault();
		}

		const isActive = this.classList.contains('kt-active');

		if (isActive) {
			this.setOpenState(false);
		} else {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.setOpenState(true);
		}
	}

	adjustSubmenuPosition(submenu) {
		submenu.classList.remove('kt-menu__submenu--flip');
		submenu.style.removeProperty('--submenu-nudge-x');
		submenu.style.removeProperty('--submenu-nudge-y');

		const vw = window.innerWidth;
		const vh = window.innerHeight;
		const hostRect = this.getBoundingClientRect();
		const spaceRight = vw - hostRect.right;
		const spaceLeft = hostRect.left;

		let rect = submenu.getBoundingClientRect();
		const needFlip = rect.width > spaceRight && spaceLeft >= spaceRight;

		submenu.classList.toggle('kt-menu__submenu--flip', needFlip);
		rect = submenu.getBoundingClientRect();

		let nudgeX = 0;
		if (rect.left < 0) nudgeX = -rect.left;
		else if (rect.right > vw) nudgeX = vw - rect.right;

		let nudgeY = 0;
		if (rect.top < 0) nudgeY = -rect.top;
		else if (rect.bottom > vh) nudgeY = vh - rect.bottom;

		if (nudgeX !== 0) submenu.style.setProperty('--submenu-nudge-x', `${Math.round(nudgeX)}px`);
		if (nudgeY !== 0) submenu.style.setProperty('--submenu-nudge-y', `${Math.round(nudgeY)}px`);
	}

}

customElements.define('item-is-dropdown', itemIsDropdown);

// item-is-megamenu class ( used for all megamenus in the classic header menu )

class itemIsMegamenu extends KtBaseMenuItem {
	constructor() {
		super();
		this.handleClick = this.handleClick.bind(this);
		this.handleKeydown = this.handleKeydown.bind(this);
		this.handleMouseEnter = this.handleMouseEnter.bind(this);
	}

	connectedCallback() {
		this.link = this.querySelector('.kt-menu__link');
		this.menu = this.querySelector('.kt-megamenu');
		if (!this.link || !this.menu) return;

		this.setExpanded(false);
		this.link.addEventListener('click', this.handleClick);
		this.link.addEventListener('keydown', this.handleKeydown);
		if ( ! ktTouchEvents ) {
			this.link.addEventListener('mouseenter', this.handleMouseEnter);
		}
	}

	disconnectedCallback() {
		if (this.link) {
			this.link.removeEventListener('click', this.handleClick);
			this.link.removeEventListener('keydown', this.handleKeydown);
			if ( ! ktTouchEvents ) {
				this.link.removeEventListener('mouseenter', this.handleMouseEnter);
			}
		}
	}

	// the trigger is <a tabindex="0">, with an optional href. Enter must always
	// toggle the megamenu for keyboard users, so handle it explicitly here.
	handleKeydown(e) {
		if ( e.keyCode !== window.KEYCODES.RETURN ) return;
		this.toggle(e);
	}

	handleMouseEnter(e) {
		e.preventDefault();
		e.stopPropagation();
		if ( ! this.menu.classList.contains('kt-opened') ) {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.open();
		}
	}

	// with an href on desktop: hover opens, click navigates. On touch devices
	// ( no hover ) the first tap still has to open the megamenu.
	handleClick(e) {
		if ( this.link.hasAttribute('href') && ! ktTouchEvents ) return;
		this.toggle(e);
	}

	toggle(e) {
		e.preventDefault();
		e.stopPropagation();

		const willOpen = !this.menu.classList.contains('kt-opened');

		if (willOpen) {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		this.menu.classList.add('kt-opened');
		if (this.link) {
			this.link.classList.add('kt-active');
		}
		this.setExpanded(true);
		this.updateHeader();
	}

	close() {
		this.menu.classList.remove('kt-opened');
		if (this.link) {
			this.link.classList.remove('kt-active');
		}
		this.setExpanded(false);

		this.closeDescendants();

		this.updateHeader();
	}
}

customElements.define('item-is-megamenu', itemIsMegamenu);